import {RootState} from '@/store';
import {createSlice} from '@reduxjs/toolkit';

import {OrderDetailsItem, OrdersState} from '../types';

import {
  clearCustomersShipNames,
  clearOrderDetails,
  fetchCustomersBillNames,
  fetchCustomersShipNames,
  fetchOrderDetails,
  fetchOrderDetailsCounts,
} from '../actions';

const name = 'home';

const initialState: OrdersState = {
  orderDetails: {data: [], loading: false, count: 0},
  orderDetailsCounts: {
    loading: false,
    data: {
      titlesCount: 0,
      shipmentsCount: 0,
      shippingStatusCount: null,
      poStatusCount: null,
    },
  },
  customersBillName: {data: null, loading: false},
  customersShipName: {data: null, loading: false},
};

const homeSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchOrderDetails.pending, state => {
        state.orderDetails.loading = true;
      })
      .addCase(
        fetchOrderDetails.fulfilled,
        (state, {payload: {count, results}}) => {
          state.orderDetails.loading = false;
          state.orderDetails.data = results;
          state.orderDetails.count = count;
        }
      )
      .addCase(fetchOrderDetails.rejected, state => {
        state.orderDetails.loading = false;
      })
      .addCase(fetchOrderDetailsCounts.pending, state => {
        state.orderDetailsCounts.loading = true;
      })
      .addCase(
        fetchOrderDetailsCounts.fulfilled,
        (
          state,
          {
            payload: {
              payload: {
                titles_count,
                shipments_count,
                shipping_status_count,
                po_status_count,
              },
            },
          }
        ) => {
          state.orderDetailsCounts.loading = false;
          state.orderDetailsCounts.data = {
            titlesCount: titles_count,
            shipmentsCount: shipments_count,
            shippingStatusCount: shipping_status_count,
            poStatusCount: po_status_count,
          };
        }
      )
      .addCase(fetchOrderDetailsCounts.rejected, state => {
        state.orderDetailsCounts.loading = false;
      })
      .addCase(fetchCustomersBillNames.pending, state => {
        state.customersBillName.loading = true;
      })
      .addCase(
        fetchCustomersBillNames.fulfilled,
        (state, {payload: {payload}}) => {
          state.customersBillName.loading = false;
          state.customersBillName.data = payload;
        }
      )
      .addCase(fetchCustomersBillNames.rejected, state => {
        state.customersBillName.loading = false;
        state.customersBillName.data = null;
      })
      .addCase(fetchCustomersShipNames.pending, state => {
        state.customersShipName.loading = true;
      })
      .addCase(
        fetchCustomersShipNames.fulfilled,
        (state, {payload: {payload}}) => {
          state.customersShipName.loading = false;
          state.customersShipName.data = payload;
        }
      )
      .addCase(fetchCustomersShipNames.rejected, state => {
        state.customersShipName.loading = false;
        state.customersShipName.data = null;
      })
      .addCase(clearCustomersShipNames, state => {
        state.customersShipName = initialState.customersShipName;
      })
      .addCase(clearOrderDetails, state => {
        state.orderDetails = initialState.orderDetails;
        state.orderDetailsCounts = initialState.orderDetailsCounts;
      });
  },
});

export default homeSlice;

export const selectOrderDetails = (state: RootState): OrderDetailsItem[] =>
  state[name].orderDetails.data;

export const selectOrderDetailsCount = (state: RootState): number =>
  state[name].orderDetails.count;

export const selectOrderDetailsLoading = (state: RootState): boolean =>
  state[name].orderDetails.loading;

export const selectOrderDetailsCountsLoading = (state: RootState): boolean =>
  state[name].orderDetailsCounts.loading;

export const selectOrderDetailsTitlesCount = (state: RootState): number =>
  state[name].orderDetailsCounts.data.titlesCount;

export const selectOrderDetailsShipmentsCount = (state: RootState): number =>
  state[name].orderDetailsCounts.data.shipmentsCount;

export const selectOrderDetailsPoStatusCount = (
  state: RootState
): Record<string, number> | null =>
  state[name].orderDetailsCounts.data.poStatusCount;

export const selectOrderDetailsShippingStatusCount = (
  state: RootState
): Record<string, number> | null =>
  state[name].orderDetailsCounts.data.shippingStatusCount;

export const selectCustomersBillName = (state: RootState): string | null =>
  state[name].customersBillName.data;

export const selectCustomersBillNameLoading = (state: RootState): boolean =>
  state[name].customersBillName.loading;

export const selectCustomersShipName = (state: RootState): string | null =>
  state[name].customersShipName.data;

export const selectCustomersShipNameLoading = (state: RootState): boolean =>
  state[name].customersShipName.loading;
